import React from 'react';
import { CohortTimeframe } from "../../components/cohort-timeframe/CohortTimeframe";
import { useAppSelector } from '../../hooks';
import { selectCurrent } from './cohortBuilderSlice';
import { CohortSummary } from './CohortSummary';

const CohortSummaryReport = () => {
  const study = useAppSelector(selectCurrent).study!
  const query = useAppSelector(selectCurrent).query!
  const sparkQuery = query.sparkQuery!
  const request = JSON.parse(sparkQuery.request).request
  const response = sparkQuery.response ? JSON.parse(sparkQuery.response) : undefined
  return <div>
    <CohortTimeframe />
    <CohortSummary
        label={study.title}
        period={request.period}
        groups={request.groups}
        count={response ? response.count : null}
        tracker={response ? response.tracker : null}
    />
  </div>
}

export default CohortSummaryReport